<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-card elevation="6">
        <div class="pa-3">
          <BinTitle :title="product_source" :price="total_all" :type="header_list.unit" :value="format_price(price_all)"/>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="binHeader" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ diffDateTH(dataDetail.item.date_expired) }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>{{ item_unit = dataDetail.item.unit_name }}</td>
                <td>{{ format_price(dataDetail.item.cost) }} บาท</td>
                <td>{{ dataDetail.item.supplier }}</td>
                <td>
                  <div class="grid_unit">
                    <div class="red--text text-center">{{ format_price(dataDetail.item.total_dump) }}</div>
                    <div class="red--text text-left">บาท</div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import BinTitle from "./header_bin/BinTitle";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Bin_details",
  components: {BinTitle},
  data() {
    return {
      loading_page: false,
      search: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      binHeader: [
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '170px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคา',
          value: 'cost',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier',
          fixed: true,
          width: '250px',
        },
        {
          text: 'มูลค่าสินค้าทิ้ง',
          value: 'total_dump',
          fixed: true,
          width: '200px',
        },
      ],
      header_list: [],
      product_source: null,
      data_list: [],
    }
  },
  methods: {
    format_price: function(value) {
      return formatPrice(value)
    },
    format_number: function(value) {
      return formatNumber(value)
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      return day+'/'+month+'/'+year
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/dumps/getdumpproduct', {
        product_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.product_source = res.data.object.head.product.name
          this.header_list = res.data.object.head
          this.data_list = res.data.object.lists
        }
      })
    },
  },
  computed: {
    total_all() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = number.quantity
        if (total_price < 0) {
          return sum+(0);
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result
    },
    price_all() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = parseFloat(number.total_dump)
        if (total_price < 0) {
          return sum+(0);
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_unit {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
